import { render } from "./TabelaExibicao.vue?vue&type=template&id=6def410b&scoped=true"
import script from "./TabelaExibicao.vue?vue&type=script&lang=js"
export * from "./TabelaExibicao.vue?vue&type=script&lang=js"

import "./TabelaExibicao.vue?vue&type=style&index=0&id=6def410b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6def410b"]])

export default __exports__